import { useState } from 'react'

const Disclosure = () => {
  const [show, setShow] = useState(false)

  return (
    <>
      <button
        onClick={() => setShow(true)}
        type="button"
        className="mt-4 Button Button--bare text-sm text-crop-none border-0 text-blue-600 hover:text-blue-700"
        data-target="#get-data-modal"
      >
        How we get our data
      </button>

      <div
        id="get-data-modal"
        className={`Modal ${show ? '' : 'is-closed'}`}
        role="dialog"
        aria-hidden="true"
      >
        <button
          className="Modal-overlay"
          data-target="get-data-modal"
          onClick={() => setShow(false)}
          aria-label="close"
        ></button>
        <div className="Modal-container" role="document">
          <div className="text-left p-6 bg-white shadow-xl rounded-lg max-w-3xl">
            <h3 className="type-heading-four mb-8" id="get-data-modal-title">
              How we get our data
            </h3>
            <p className="text-base text-gray-700">
              We receive our data from third-party partners about agents&apos;
              performance by the zip code they operate in. This data is then
              mapped to a general location to provide a comprehensive view of
              agent performance in a given area.
            </p>
          </div>

          <button
            onClick={() => setShow(false)}
            className="Modal-close"
            type="button"
            data-target="get-data-modal"
            aria-label="close"
          ></button>
        </div>
      </div>
    </>
  )
}

export default Disclosure
